import {
  LoginStepType,
  LoginUserDataType
} from "@website/widget/login/login.types";
import { useCallback, useState } from "react";

export const useB2BLogin = () => {
  const [currentStep, setCurrentStep] = useState<string>("phone-number");

  const setStep = useCallback((step: LoginStepType) => {
    setCurrentStep(step);
  }, []);

  const [userData, setUserData] = useState<LoginUserDataType>({
    phoneNumber: "",
    userExists: false,
    hasPassword: false,
    accessToken: "",
    refreshToken: "",
    forgotPassword: false,
    message: "",
    otpLength: 0,
    otpValidUntil: 0,
    otpId: "",
    otp: "",
    contractId: ""
  });

  return {
    step: currentStep,
    setStep,
    userData,
    setUserData
  };
};
